(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function initForm(form) {
    var select = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceEl = form.querySelector('[data-product-price]');
    var netEl = form.querySelector('[data-net-price]');
    var submitBtn = form.querySelector('[data-product-submit]');
    if (!select || !idInput) return;

    var strings = window.emdProductStrings || {};

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      idInput.value = option.value;

      if (priceEl && option.dataset.price) {
        priceEl.textContent = formatMoney(parseInt(option.dataset.price, 10));
      }

      if (netEl && option.dataset.price) {
        var rate = parseFloat(netEl.dataset.taxRate);
        var netCents = Math.round(parseInt(option.dataset.price, 10) * 100 / (100 + rate));
        netEl.textContent = (netEl.dataset.netTemplate || '').replace('__PRICE__', formatMoney(netCents));
      }

      var available = option.dataset.available === 'true';
      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.textContent = available ? strings.addToCart : strings.soldOut;
      }
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(initForm);
})();
